// extracted by css-extract-rspack-plugin
export default {"list":"SpecifiedWorks__list--Ljsme","listItem":"SpecifiedWorks__listItem--KZ9H4"};